import React from 'react';
import AppImage from '@/components/ui/AppImage';


export default function HeroSection() {
  return (
    <section className="flex flex-col items-center justify-center px-6 pt-12 pb-10 text-center bg-background">
      {/* Logo */}
      <div className="mb-4">
        <AppImage
          src="/assets/images/angna-icon-1789527716997.png"
          alt="Angna logo — arch and tulsi mark"
          width={200}
          height={200}
          priority
          className="mx-auto"
        />
      </div>

      {/* Brand Name */}
      <h1
        className="font-serif text-5xl font-bold tracking-wide mb-1"
        style={{ color: 'var(--primary)' }}
      >
        ANGNA
      </h1>

      {/* Tagline */}
      <p
        className="text-base font-medium mb-6 tracking-wider"
        style={{ color: 'var(--secondary)' }}
      >
        Bihar Ka Swad, Ghar Ka Pyaar
      </p>

      {/* Ornament divider */}
      <div className="divider-ornament w-48 mb-6">
        <span className="text-xs font-serif" style={{ color: 'var(--secondary)' }}>
          ✦
        </span>
      </div>

      {/* Headline */}
      <h2
        className="font-serif text-2xl font-semibold mb-3 leading-snug"
        style={{ color: 'var(--foreground)' }}
      >
        A little taste of home.
      </h2>

      {/* Description */}
      <p
        className="text-sm leading-relaxed max-w-xs mb-8"
        style={{ color: 'var(--muted-foreground)' }}
      >
        Pure, homemade Bihari snacks — thekua, nimki, chura Bhuja, laung lata — made the way they&apos;re made in a real angna, not a factory.
      </p>

      {/* CTA */}
      <a href="#products" className="btn-primary text-sm px-8 py-3 no-underline">
        Pick your box
      </a>
    </section>
  );
}